import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { useNavigate } from "react-router-dom";
import { X, LifeBuoy, BookOpen, MessageCircle, FileText, Shield, Sparkles } from "lucide-react";
import "../style/help-modal.css";

export default function HelpModal({ isOpen, onClose }) {
  const navigate = useNavigate();

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };
    if (isOpen) {
      window.addEventListener("keydown", handleKeyDown);
      return () => window.removeEventListener("keydown", handleKeyDown);
    }
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleLink = (path) => {
    onClose();
    navigate(path);
  };

  return ReactDOM.createPortal(
    <div className="help-modal-overlay" onClick={onClose}>
      <div className="help-modal-card" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="help-modal-header">
          <div className="help-modal-title-wrap">
            <div className="help-modal-icon-badge">
              <LifeBuoy size={20} />
            </div>
            <div>
              <h2 className="help-modal-title">Help & Support</h2>
              <p className="help-modal-subtitle">Guides, shortcuts and support for GRGPT</p>
            </div>
          </div>
          <button
            type="button"
            className="help-modal-close-btn"
            onClick={onClose}
            aria-label="Close"
          >
            <X size={18} />
          </button>
        </div>

        {/* Body Options */}
        <div className="help-modal-body">
          <button
            type="button"
            className="help-option-row"
            onClick={() => handleLink("/subscription")}
          >
            <div className="help-option-icon">
              <Sparkles size={18} />
            </div>
            <div className="help-option-text">
              <span className="help-option-title">Plans & Pricing</span>
              <span className="help-option-desc">Compare plans, upgrade credits and limits</span>
            </div>
            <span className="help-option-arrow">›</span>
          </button>

          <button
            type="button"
            className="help-option-row"
            onClick={() => handleLink("/terms")}
          >
            <div className="help-option-icon">
              <BookOpen size={18} />
            </div>
            <div className="help-option-text">
              <span className="help-option-title">Terms & Conditions</span>
              <span className="help-option-desc">Read our platform terms and guidelines</span>
            </div>
            <span className="help-option-arrow">›</span>
          </button>

          <button
            type="button"
            className="help-option-row"
            onClick={() => handleLink("/privacy")}
          >
            <div className="help-option-icon">
              <Shield size={18} />
            </div>
            <div className="help-option-text">
              <span className="help-option-title">Privacy Policy</span>
              <span className="help-option-desc">Learn how your data is protected</span>
            </div>
            <span className="help-option-arrow">›</span>
          </button>

          <button
            type="button"
            className="help-option-row"
            onClick={() => handleLink("/return-policy")}
          >
            <div className="help-option-icon">
              <FileText size={18} />
            </div>
            <div className="help-option-text">
              <span className="help-option-title">Return & Cancellation Policy</span>
              <span className="help-option-desc">Details on refunds and subscription billing</span>
            </div>
            <span className="help-option-arrow">›</span>
          </button>

          <button
            type="button"
            className="help-option-row"
            onClick={() => handleLink("/contact")}
          >
            <div className="help-option-icon">
              <MessageCircle size={18} />
            </div>
            <div className="help-option-text">
              <span className="help-option-title">Contact Support</span>
              <span className="help-option-desc">Reach out to grgptsupport@gmail.com for assistance</span>
            </div>
            <span className="help-option-arrow">›</span>
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
